module.exports = __webpack_public_path__ + "img/battletrip_section2_left.df97c7d8.png";